(() => {
  function init(root) {
    const cardsWrap = root.querySelector('[data-arc-cards]');
    const prevBtn = root.querySelector('[data-arc-prev]');
    const nextBtn = root.querySelector('[data-arc-next]');
    const svg = root.querySelector('.testimonials-arc__svg');
    const path = svg && svg.querySelector('path');
    if (!cardsWrap || !svg || !path) return;

    // prevent double init
    if (root.dataset.arcInited === '1') return;
    root.dataset.arcInited = '1';

    const state = { index: 0 };

    function getCards() {
      return Array.from(cardsWrap.querySelectorAll('.testimonials-arc__cards-item'));
    }
    function clamp(n, a, b) { return Math.max(a, Math.min(b, n)); }
    function getVisible() {
      const w = window.innerWidth;
      if (w <= 749) return 1;
      if (w <= 1249) return 2;
      return 4;
    }

    function pointOnPath(u) {
      const total = path.getTotalLength();
      const p = path.getPointAtLength(u * total);

      const svgPoint = svg.createSVGPoint();
      svgPoint.x = p.x;
      svgPoint.y = p.y;

      const screenPoint = svgPoint.matrixTransform(svg.getScreenCTM());
      const wrapRect = cardsWrap.getBoundingClientRect();

      return { x: screenPoint.x - wrapRect.left, y: screenPoint.y - wrapRect.top };
    }

    function tangentDeg(u) {
      const total = path.getTotalLength();
      const len = u * total;
      const delta = total * 0.002;

      const p1 = path.getPointAtLength(clamp(len - delta, 0, total));
      const p2 = path.getPointAtLength(clamp(len + delta, 0, total));

      return (Math.atan2(p2.y - p1.y, p2.x - p1.x) * 180) / Math.PI;
    }

    function layout() {
      const visible = getVisible();
      const cards = getCards();
      const total = cards.length;
      if (!total) return;

      state.index = ((state.index % total) + total) % total;

      const centerOffset = (visible - 1) / 2;

      let step;
      if (visible === 4) step = 0.25;
      else if (visible === 2) step = 0.4;
      else step = 0.85;

      const centerU = 0.5;
      const minU = 0.12;
      const maxU = 0.88;

      const buffer = 1;
      const minRel = -buffer;
      const maxRel = visible - 1 + buffer;

      function relToU(rel) {
        const slotPosition = rel - centerOffset;
        return centerU + slotPosition * step;
      }

      function pointWithOverflow(u) {
        const wrapRect = cardsWrap.getBoundingClientRect();
        const w = wrapRect.width || 1;

        let overflow = 0;
        let uc = u;

        if (u < minU) { overflow = u - minU; uc = minU; }
        else if (u > maxU) { overflow = u - maxU; uc = maxU; }

        const pt = pointOnPath(uc);
        const angleDeg = tangentDeg(uc);
        const angleRad = (angleDeg * Math.PI) / 180;

        const dirX = Math.cos(angleRad);
        const dirY = Math.sin(angleRad);

        const distance = overflow * w * 0.9;

        return { x: pt.x + dirX * distance, y: pt.y + dirY * distance, uc };
      }

      cards.forEach((card) => {
        card.style.opacity = 0;
        card.style.pointerEvents = 'none';
      });

      for (let rel = minRel; rel <= maxRel; rel++) {
        const realIndex = (state.index + rel + total) % total;
        const card = cards[realIndex];
        if (!card) continue;

        const uRaw = relToU(rel);
        const p = pointWithOverflow(uRaw);
        const rot = tangentDeg(p.uc) * 0.6;

        const anchor = card.querySelector('.testimonials-arc__pinAnchor');
        const ax = anchor ? anchor.offsetLeft : card.offsetWidth / 2;
        const ay = anchor ? anchor.offsetTop : 0;

        card.style.transform = `translate(${p.x - ax}px, ${p.y - ay}px) rotate(${rot}deg)`;

        if (rel >= 0 && rel <= visible - 1) {
          card.style.opacity = 1;
          card.style.pointerEvents = 'auto';
          card.style.zIndex = 10 - rel;
        } else {
          card.style.opacity = 0;
          card.style.pointerEvents = 'none';
          card.style.zIndex = 1;
        }
      }
    }

    const next = () => { state.index++; layout(); };
    const prev = () => { state.index--; layout(); };

    nextBtn && nextBtn.addEventListener('click', next);
    prevBtn && prevBtn.addEventListener('click', prev);
    window.addEventListener('resize', layout);

    requestAnimationFrame(layout);
  }

  function scan(scope = document) {
    scope.querySelectorAll('[data-testimonials-arc]').forEach(init);
  }

  // initial
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
  } else {
    scan();
  }

  // theme editor / section re-render
  document.addEventListener('shopify:section:load', (e) => scan(e.target));
})();